import React from "react";

function ContractTeam() {
  return <div>ContractTeam</div>;
}

export default ContractTeam;
